module.exports = __webpack_public_path__ + "img/roles_2.72d44f9f.png";